module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (45).9083beb3.jpg";